import { E_BUSINESS_CASE_VOCABULARIES } from './e-business-case.js';
import { E_CONFIG_SETTINGS_VOCABULARIES } from './e-config-settings.js';
import { E_DISPATCH_DRIVER_VOCABULARIES } from './e-dispatch-driver.js';
import { E_OPERATOR_PAYMENTS_VOCABULARIES } from './e-operator-payments.js';
import { E_OPS_STORES_VOCABULARIES } from './e-ops-stores.js';
import { E_UI_MISC_VOCABULARIES } from './e-ui-misc.js';
/** Slice e of the catalog (D577): the exported vocabularies the first inventory missed (`*-store` packages, app shell, code added later). */
export const SLICE_E = [
    ...E_BUSINESS_CASE_VOCABULARIES,
    ...E_CONFIG_SETTINGS_VOCABULARIES,
    ...E_DISPATCH_DRIVER_VOCABULARIES,
    ...E_OPERATOR_PAYMENTS_VOCABULARIES,
    ...E_OPS_STORES_VOCABULARIES,
    ...E_UI_MISC_VOCABULARIES,
];
//# sourceMappingURL=slice-e.js.map